export default __webpack_public_path__ + "static/media/logoIcon.69f61e92.svg";